

export default [
  {
    title: 'ข้อมูลคำสั่งซื้อ',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'รายการข้อมูล',
        route: 'order-list',
      },
      {
        title: 'ดูข้อมูล',
        route: { name: 'order-view', params: { id: 4987 } },
        disabled: true,
      },
      // {
      //   title: 'แก้ไขข้อมูล',
      //   route: { name: 'order-edit', params: { id: 4987 } },
      //   disabled: true,
      // },
      // {
      //   title: 'เพิ่มข้อมูล',
      //   route: { name: 'order-add' },
      // },
    ],
  },
  {
    title: 'ข้อมูลผู้ใช้งาน (User)',
    icon: 'UserIcon',
    children: [
      {
        title: 'รายการข้อมูล',
        route: 'user-list',
      },
      {
        title: 'ดูข้อมูล',
        route: { name: 'user-view', params: { id: 4987 } },
        disabled: true,
      },
      
    ],
  },
]
